import React from "react";

export default function CheckBox({ children, ...props }) {
  return (
    <div className="check_box_container">
      <input type="checkbox" {...props} />
      <span className="tick">
        <svg
          width="14"
          height="11"
          viewBox="0 0 14 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.28516 6.42856L5.28516 9.42856L12.1423 1.71428"
            stroke="white"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>
    </div>
  );
}
